import Axios from 'axios';

import Cache from '@/core/lib/Cache';

export interface SoaConfigAuthentication {
  url: string;
  realm: string;
  clientId: string;
}

export interface SoaConfigAlptisApi {
  baseUrl: string;
  apiKey: string;
  serviceEspaceDistributeur: string;
  endpointArchivageProjetCollectif: string;
}

export interface SoaConfigApmAgent {
  environment: string;
  serverUrl: string;
  serverUrlPrefix: string;
  active: boolean;
}

export interface SoaConfigFeatureFlags {
  haumea: boolean;
  tally: boolean;
  madelin: {
    maxFilePerArchive?: number;
  };
}

export interface SoaConfig {
  marque: string;
  espaceDigitalHomeUrl: string;
  evcApiBaseUrl: string;
  contractDocumentOrderUrl: string;
  authentication: SoaConfigAuthentication;
  apiAlptis: SoaConfigAlptisApi;
  apmAgent: SoaConfigApmAgent;
  feature: SoaConfigFeatureFlags;
}

const cache = new Cache<Promise<SoaConfig>>();

export async function getConfig(): Promise<SoaConfig> {
  return cache.getOrSet('soa-config', async () => {
    const response = await Axios.get<SoaConfig>('/config.json');

    return response.data;
  });
}
